import { render } from "./SheetClose.vue?vue&type=template&id=79326e1f&ts=true"
import script from "./SheetClose.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetClose.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sheet/SheetClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79326e1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79326e1f', __exports__)) {
    api.reload('79326e1f', __exports__)
  }
  
  module.hot.accept("./SheetClose.vue?vue&type=template&id=79326e1f&ts=true", () => {
    api.rerender('79326e1f', render)
  })

}


export default __exports__